module.exports = __webpack_public_path__ + "static/media/icons_Bilan réhabilitation respiratoire.3fb3c3b1.svg";